import React from 'react';

import { Icon } from '@chakra-ui/react';
import { MdLock } from 'react-icons/md';
import {
  FaAddressBook,
  FaCalendarAlt,
  FaUserAlt,
  FaGraduationCap,
  FaChalkboardTeacher,
  FaUserGraduate,
  FaClipboardList,
  FaCogs,
  FaExchangeAlt,
  FaPercentage,
  FaDollarSign,
  FaCreditCard,
  FaBook,
  FaFileInvoiceDollar,
  FaClock,
} from 'react-icons/fa';

// Admin Imports
import Students from './views/admin/students';
import Teaching from './views/admin/teaching';
import Profile from './views/admin/profile';
import Studies from './views/admin/studies';
import StudyPlan from './views/admin/studyPlan';
import Subjects from './views/admin/subjects';
import DictatedCoursesManagement from './views/admin/dictatedCourses';
import DictatedCourseListView from './views/admin/dictatedCourses/ListView';
import DictatedCourseAbsencesView from './views/admin/dictatedCourses/AbsencesView';
import DictatedCourseTeachersView from './views/admin/dictatedCourses/TeachersView';
import DictatedCourseActaView from './views/admin/dictatedCourses/ActaView';
import CourseInscriptions from './views/admin/courseInscriptions';
import Inscriptions from './views/admin/inscriptions';
import Revalidations from './views/admin/revalidations/complete.jsx';
import CourseDiscounts from './views/admin/courseDiscounts';
import PriceIncreases from './views/admin/priceIncreases';
import Employees from './views/admin/employees';
import EmployeeProfile from './components/employees/Profile';
import PaymentMethods from './views/admin/paymentMethods';
import LibraryMedia from './views/admin/library';
import LibraryLoans from './views/admin/library/loans';

import ExamInscription from './views/admin/examInscription';
import CurrentAccount from './views/admin/currentAccount';
import ExamList from './views/admin/examList';
// Stubs de ACTA / MESA EXAMINADORA por examen individual (Módulo 7).
import ExamActaView from './views/admin/exams/ActaView';
import ExamTribunalView from './views/admin/exams/TribunalView';
import PayrollPeriods from './views/admin/payroll';
import LiquidacionesView from './views/admin/payroll/LiquidacionesView';
import EmployeePayrollConfigView from './views/admin/payroll/EmployeePayrollConfigView';
import SalaryIncreasesView from './views/admin/payroll/SalaryIncreasesView';
import AbsenceManagementView from './views/admin/payroll/AbsenceManagementView';
import DashboardView from './views/admin/DashboardView';
import ScholarshipView from './views/admin/ScholarshipView';
import CourseAttendanceView from './views/admin/CourseAttendanceView';
import EmployeeContractsView from './views/admin/EmployeeContractsView';
import DelinquencyView from './views/admin/DelinquencyView';
import AuditLogView from './views/admin/AuditLogView';
import CalendarView from './views/admin/CalendarView';
import ClassroomsView from './views/admin/ClassroomsView';
import ImportEscolaridadesView from './views/admin/ImportEscolaridadesView';
import InstitutionConfigView from './views/admin/InstitutionConfigView';
import EmployeeDocumentsView from './views/admin/EmployeeDocumentsView';
import SystemAdministration from './views/admin/SystemAdministration';
import ReportsView from './views/admin/reports';
import StudyTypesView from './views/admin/studyTypes';
import TimeClockView from './views/admin/timeRecord/TimeClockView';
import TimeRecordReportView from './views/admin/timeRecord/TimeRecordReportView';
import UserManagementView from './views/admin/UserManagementView';
import UnauthorizedView from './views/admin/UnauthorizedView';
import { enrichRoutesWithAccess } from './config/routeAccessMap';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
// import Profile from 'components/students/Profile';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={FaClipboardList} width="20px" height="20px" color="inherit" />,
    component: <DashboardView />,
    showSearch: false,
    showInNavbar: false,
  },
  {
    name: 'Bedelia',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={FaUserGraduate} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Estudiantes',
        layout: '/admin',
        // icon: (
        //   <Icon as={FaUserAlt} width="20px" height="20px" color="inherit" />
        // ),
        path: '/default',
        component: <Students />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Datos del estudiante',
        layout: '/admin',
        path: '/default/:id',
        component: <Profile />,
        showSearch: false,
        showInNavbar: false,
      },
      {
        name: 'Reválidas',
        layout: '/admin',
        path: '/revalidations',
        component: <Revalidations />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Descuentos',
        layout: '/admin',
        path: '/course-discounts',
        component: <CourseDiscounts />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Becas',
        layout: '/admin',
        path: '/scholarships',
        component: <ScholarshipView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Docentes',
        layout: '/admin',
        // icon: (
        //   <Icon as={FaUserAlt} width="20px" height="20px" color="inherit" />
        // ),
        path: '/teaching',
        component: <Teaching />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Datos del docente',
        layout: '/admin',
        path: '/teaching/:id',
        component: <EmployeeProfile />,
        showSearch: false,
        showInNavbar: false,
      },
    ],
  },
  {
    name: 'Dictados',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={FaChalkboardTeacher} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Inscripciones',
        layout: '/admin',
        path: '/inscriptions',
        component: <Inscriptions />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Dictados',
        layout: '/admin',
        path: '/dictated-courses',
        component: <DictatedCoursesManagement />,
        showSearch: true,
        showInNavbar: true,
      },
      // Sub-vistas por dictado (accesos desde la grilla).
      {
        name: 'Lista de inscriptos',
        layout: '/admin',
        path: '/dictated-courses/:id/list',
        component: <DictatedCourseListView />,
        showSearch: false,
        showInNavbar: false,
      },
      {
        name: 'Inasistencias del dictado',
        layout: '/admin',
        path: '/dictated-courses/:id/absences',
        component: <DictatedCourseAbsencesView />,
        showSearch: false,
        showInNavbar: false,
      },
      {
        name: 'Docentes del dictado',
        layout: '/admin',
        path: '/dictated-courses/:id/teachers',
        component: <DictatedCourseTeachersView />,
        showSearch: false,
        showInNavbar: false,
      },
      {
        name: 'Acta del dictado',
        layout: '/admin',
        path: '/dictated-courses/:id/acta',
        component: <DictatedCourseActaView />,
        showSearch: false,
        showInNavbar: false,
      },
    ],
  },
  {
    name: 'Exámenes',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={FaClipboardList} width="20px" height="20px" color="inherit" />
    ),
    items: [
      // Requerimiento cliente (Módulo 7):
      //   - Estructura "Exámenes" con dos sub-items: "Inscripciones" y "Exámenes".
      //   - NO hay más períodos de examen: cada examen es individual.
      //   - Se conserva la vista de "Períodos de Examen" en el repo pero
      //     oculta del navbar (showInNavbar: false) hasta confirmar si se
      //     elimina por completo o se usa internamente.
      {
        name: 'Inscripciones',
        layout: '/admin',
        path: '/exam-inscriptions',
        component: <ExamInscription />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Exámenes',
        layout: '/admin',
        path: '/exams',
        component: <ExamList />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        // Stub oculto: pantalla de ACTA de un examen individual.
        name: 'Acta de examen',
        layout: '/admin',
        path: '/exams/:id/acta',
        component: <ExamActaView />,
        showSearch: false,
        showInNavbar: false,
      },
      {
        // Stub oculto: pantalla de MESA EXAMINADORA (asignar tribunal).
        name: 'Mesa examinadora',
        layout: '/admin',
        path: '/exams/:id/tribunal',
        component: <ExamTribunalView />,
        showSearch: false,
        showInNavbar: false,
      },
    ]
  },
  {
    name: 'Finanzas',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={FaDollarSign} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Cuenta Corriente',
        layout: '/admin',
        path: '/current-account',
        component: <CurrentAccount />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Aumentos',
        layout: '/admin',
        path: '/price-increases',
        component: <PriceIncreases />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Empleados',
        layout: '/admin',
        path: '/employees',
        component: <Employees />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Perfil de Empleado',
        layout: '/admin',
        path: '/employees/:id',
        component: <EmployeeProfile />,
        showSearch: false,
        showInNavbar: false,
      },
      {
        name: 'Planes de Pago',
        layout: '/admin',
        path: '/payment-methods',
        component: <PaymentMethods />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Historial de contratos',
        layout: '/admin',
        path: '/employee-contracts',
        component: <EmployeeContractsView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Legajo Digital',
        layout: '/admin',
        path: '/employee-documents',
        component: <EmployeeDocumentsView />,
        showSearch: false,
        showInNavbar: false,
      },
      {
        name: 'Morosidad',
        layout: '/admin',
        path: '/delinquency',
        component: <DelinquencyView />,
        showSearch: false,
        showInNavbar: true,
      },
    ],
  },
  {
    name: 'Liquidaciones',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={FaFileInvoiceDollar} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Períodos de Liquidación',
        layout: '/admin',
        path: '/payroll',
        component: <PayrollPeriods />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Calcular Liquidación',
        layout: '/admin',
        path: '/payroll-management',
        component: <LiquidacionesView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Configurar Aportes',
        layout: '/admin',
        path: '/employee-payroll-config',
        component: <EmployeePayrollConfigView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Aumentos Salariales',
        layout: '/admin',
        path: '/salary-increases',
        component: <SalaryIncreasesView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Gestión de Ausencias',
        layout: '/admin',
        path: '/absence-management',
        component: <AbsenceManagementView />,
        showSearch: false,
        showInNavbar: true,
      },
    ],
  },
  {
    name: 'Marcas',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={FaClock} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Marcas',
        layout: '/admin',
        path: '/time-clock',
        component: <TimeClockView />,
        showSearch: false,
        showInNavbar: true,
        accesses: ['TIME_CLOCK'],
      },
      {
        name: 'Reporte de Marcas',
        layout: '/admin',
        path: '/time-record-report',
        component: <TimeRecordReportView />,
        showSearch: false,
        showInNavbar: true,
        accesses: ['TIME_CLOCK_REPORT'],
      },
    ],
  },
  {
    name: 'Administración',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={MdLock} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Sistema',
        layout: '/admin',
        path: '/system-admin',
        component: <SystemAdministration />,
        showSearch: false,
        showInNavbar: false,
      },
      {
        name: 'Usuarios y roles',
        layout: '/admin',
        path: '/user-management',
        component: <UserManagementView />,
        showSearch: false,
        showInNavbar: true,
        accesses: ['USER_MANAGEMENT'],
      },
      {
        name: 'Auditoría',
        layout: '/admin',
        path: '/audit-log',
        component: <AuditLogView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Reportes',
        layout: '/admin',
        path: '/reports',
        component: <ReportsView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Configuración Institución',
        layout: '/admin',
        path: '/institution-config',
        component: <InstitutionConfigView />,
        showSearch: false,
        showInNavbar: false,
      },
    ],
  },
  {
    name: 'Coordinación académica',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={FaCogs} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Estudios',
        layout: '/admin',
        path: '/studies',
        component: <Studies />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Tipos de estudio',
        layout: '/admin',
        path: '/study-types',
        component: <StudyTypesView />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Planes de estudio',
        layout: '/admin',
        path: '/studyPlans',
        component: <StudyPlan />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Materias',
        layout: '/admin',
        path: '/subjects',
        component: <Subjects />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Asistencia a Cursos',
        layout: '/admin',
        path: '/course-attendance',
        component: <CourseAttendanceView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Calendario Académico',
        layout: '/admin',
        path: '/academic-calendar',
        component: <CalendarView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Aulas',
        layout: '/admin',
        path: '/classrooms',
        component: <ClassroomsView />,
        showSearch: false,
        showInNavbar: true,
      },
      {
        name: 'Importar escolaridades',
        layout: '/admin',
        path: '/import-escolaridades',
        component: <ImportEscolaridadesView />,
        showSearch: false,
        showInNavbar: true,
      },
    ],
  },
  {
    name: 'Biblioteca',
    category: true,
    layout: '/admin',
    icon: (
      <Icon as={FaBook} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Medios',
        layout: '/admin',
        path: '/library',
        component: <LibraryMedia />,
        showSearch: true,
        showInNavbar: true,
      },
      {
        name: 'Préstamos',
        layout: '/admin',
        path: '/loans',
        component: <LibraryLoans />,
        showSearch: true,
        showInNavbar: true,
      },
    ],
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
    showSearch: false,
    showInNavbar: false,
  },
];

export default enrichRoutesWithAccess(routes);
